// 录入\编辑页接口
import $http from '@/resource';

const $api = {};

/**
 * 保存/编辑企业数据
 *
 * @method POST
 *
 * @param {Object} formData 保存的数据
 *
 * @returns {Promise<*>}
 *
 * @url /companys/save
 */
$api.saveCompany = async (formData) => {
    let url = `/companys/save`;
    return await $http.post(url,formData);
};

/**
 * 获取世界所有公司名称 对接搜索引擎
 * 
 * @method GET
 *
 * @param {String} word 关键字
 *
 * @url /company-name
 *
 * @return {Promise<any>}
 */
$api.getAllCompany = async (word)=>{
  const url = `/company-name`;
  return await $http.get(url,{params:{'keywords':word}});
};


export default $api;


// WEBPACK FOOTER //
// ./src/service/enterprise/input.js